module.exports = __webpack_public_path__ + "assets/c9a8f145a7675c1abb36d21a5dea66cc.png";